import React from 'react';

/**
 * Checkbox list of roles from the catalog. A user may hold several roles in one org; their
 * permissions are the union. Shows each role's description so the choice is self-explanatory.
 */
function RoleSelector({
  catalog,
  value = [],
  onChange,
  disabled = false,
  compact = false,
  idPrefix = 'role',
}) {
  const roles = catalog?.roles || [];
  const selected = new Set(value);

  const toggle = (key) => {
    const next = new Set(selected);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    // Keep catalog order so the saved list is stable.
    onChange(roles.map((r) => r.key).filter((k) => next.has(k)));
  };

  if (roles.length === 0) {
    return <p className="text-sm text-gray-500">Loading roles…</p>;
  }

  return (
    <div className={compact ? 'flex flex-wrap gap-2' : 'grid grid-cols-1 gap-2 sm:grid-cols-2'}>
      {roles.map((role) => {
        const id = `${idPrefix}-${role.key}`;
        const checked = selected.has(role.key);
        return (
          <label
            key={role.key}
            htmlFor={id}
            className={`flex cursor-pointer items-start gap-2 rounded-md border p-2 text-sm ${
              checked ? 'border-[#0062FB] bg-blue-50' : 'border-hairline bg-surface'
            } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
            title={role.description}
          >
            <input
              id={id}
              type="checkbox"
              className="mt-0.5"
              checked={checked}
              disabled={disabled}
              onChange={() => toggle(role.key)}
            />
            <span className="min-w-0">
              <span className="block font-medium text-[#18181B]">{role.label}</span>
              {!compact && <span className="block text-xs text-zinc-500">{role.description}</span>}
            </span>
          </label>
        );
      })}
    </div>
  );
}

export default RoleSelector;
